import React from "react";
import { Link } from "react-router-dom";

const ReadyToStart = () => {
  return (
    <div className="xl:max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between bg-gradient-to-r from-blue-400 to-purple-500 rounded-xl shadow-lg pt-8 md:px-16 mt-16 mb-16 text-white gap-4">
      {/* Text Section */}
      <div className="flex-1 text-center md:text-left">
        <h2 className="text-xl md:text-5xl font-bold mb-4">Are you ready to start?</h2>
        <p className="text-sm md:text-base mb-6 text-white">
          Download the app now from the Play Store or App Store and start your
          journey to smarter work and greater earnings
        </p>

        <div className="flex flex-col lg:flex-row items-center gap-4 pb-3">
          <Link to="https://apps.apple.com/in/app/pixell-installation-partner/id6743424353" target="/blank">
          <img
            src="/assests/images/LandingPage/IP/appStoreImage.webp"
            alt="iphone"
          />
          </Link>
          <Link to="https://play.google.com/store/apps/details?id=com.pixell.ip" target="/blank">
          <img
            src="  /assests/images/LandingPage/IP/Google_Play_StoreImage.webp"
            alt="android"
          />
          </Link>
        </div>
      </div>

      {/* Image Section */}
      <div className="flex-1">
        <img
          src="/assests/images/LandingPage/IP/ip-qr.png"
          alt="IP-QR Code"
          className="mx-auto md:ml-auto md:mr-0 max-w-[200px] md:max-w-[300px] rounded-lg"
        />
      </div>
    </div>
  );
};

export default ReadyToStart;
